module.exports = __webpack_public_path__ + "img/angna.71e08ee8.png";